import { useState, useEffect } from 'react';
import { Icon } from '@a-ui/react';
import { useSelector, useDispatch  } from 'react-redux'
import { hideCarrousel } from '../../store/slices/carrouselReducer'

import '../../styles/carrousel.scss';

const Carrousel = (props) => {

  const { visible, images, selected } = useSelector(state => state.carrousel);

  const [current, setCurrent]  = useState();

  useEffect(() => {
    if(selected) {
      setCurrent(selected)
    } else {
      setCurrent(images[0])
    }
  }, [images, visible, selected]);

  const next = () => {
    const index = images.findIndex((item) => (item.src === current.src));
    let newIndex = index + 1;
    if(!images[newIndex]) newIndex = 0;
    document.getElementById(`image-${newIndex}`).scrollIntoView();
    setCurrent(images[newIndex])
  }

  const prev = () => {
    const index = images.findIndex((item) => (item.src === current.src));
    let newIndex = index - 1;
    if(newIndex < 0 ) newIndex = images.length - 1;
    document.getElementById(`image-${newIndex}`).scrollIntoView();
    setCurrent(images[newIndex])
  }

  const downHandler = ({ key  }) => {
    if (key === "Escape") {
      dispatch(hideCarrousel());
    }
    if (key === "ArrowRight") next();
    if (key === "ArrowLeft") prev();
  };

  useEffect(() => {
    if(visible) window.addEventListener("keydown", downHandler);
    return () => window.removeEventListener("keydown", downHandler);
  });
  const dispatch = useDispatch();
  if(!visible) return;
  return <div className="carrousel">
    <Icon name="ai-remove" className="close u-margin-bottom-xs" onClick={() => {
      dispatch(hideCarrousel());
    }}/>
    <div className="carrouselContent">
      { current && <img src={current.src} alt={current.src} className="mainImage" /> }
      {
        !current && <p className="notice" > no images </p>
      }
      <div className="navigation">
      <div className="carrouselpreview">
        <div className="carrouselholder">
          {
            current && images.length > 1 && images.map(( image, i ) => {
              return <div
                className={`preview ${ current.src === image.src && "selected" }`}
                onClick={() => setCurrent(image)}
                key={`image-${i}`}
                id={`image-${i}`}>
                <img src={image.src} alt={image.src} />
              </div>
            })
          }
        </div>
        { current && images.length > 1 && <div className="navigationholder">
        <Icon name="ai-arrow-right-1" className="next" onClick={next}/>
        <Icon name="ai-arrow-left-1" className="prev" onClick={prev}/>
      </div> }
      </div>
      </div>
    </div>
  </div>
}

export default Carrousel;
